class MobileMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.hamburger = this.querySelector('.mobile-menu__hamburger');
    this.overlay = this.querySelector('.mobile-menu__overlay');
    this.closeBtn = this.querySelector('.mobile-menu__close');
    this.backdrop = this.querySelector('.mobile-menu__backdrop');
    this.views = this.querySelectorAll('.mobile-menu__view');

    if (!this.hamburger || !this.overlay) return;

    /* Capture every button reference before moving the overlay out of this
       element's subtree below — once moved, `this.querySelectorAll` would
       no longer find descendants that now live under <body> instead. */
    var openButtons = this.querySelectorAll('[data-open]');
    var backButtons = this.querySelectorAll('[data-back]');
    var toggleButtons = this.querySelectorAll('[data-toggle]');
    var searchTrigger = this.querySelector('[data-mm-search-trigger]');

    /* The header's own animated wrapper uses CSS `transform` for its
       show/hide-on-scroll behavior. Any transformed ancestor creates a new
       containing block for `position: fixed` descendants, which would trap
       this full-screen overlay inside the header's own (short) box instead
       of the viewport. Move it to be a direct child of <body> so it always
       covers the whole screen regardless of where it started in the DOM. */
    if (this.overlay.parentElement !== document.body) {
      document.body.appendChild(this.overlay);
    }

    this.hamburger.addEventListener('click', () => this.open());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.backdrop) this.backdrop.addEventListener('click', () => this.close());

    if (searchTrigger) {
      searchTrigger.addEventListener('click', () => {
        this.close();
        var modal = document.getElementById('search-modal') || document.querySelector('search-modal');
        if (modal && typeof modal.showDialog === 'function') {
          modal.showDialog();
        } else if (modal && typeof modal.showModal === 'function') {
          modal.showModal();
        }
      });
    }

    openButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.showView(btn.getAttribute('data-open')));
    });
    backButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.showView('root'));
    });
    toggleButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        var target = this.overlay.querySelector('#' + btn.getAttribute('data-toggle'));
        if (!target) return;
        var willShow = target.hidden;
        target.hidden = !willShow;
        btn.setAttribute('aria-expanded', String(willShow));
      });
    });
  }

  open() {
    this.overlay.hidden = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.overlay.classList.add('is-open'));
    });
    this.hamburger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }

  close() {
    this.overlay.classList.remove('is-open');
    this.hamburger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    window.setTimeout(() => {
      this.overlay.hidden = true;
      this.showView('root');
    }, 320);
  }

  showView(id) {
    this.views.forEach((v) => {
      v.classList.toggle('is-active', v.getAttribute('data-view') === id);
    });
    var sheet = this.overlay.querySelector('.mobile-menu__sheet');
    if (sheet) sheet.scrollTop = 0;
  }
}

if (!customElements.get('mobile-menu-drawer')) {
  customElements.define('mobile-menu-drawer', MobileMenuDrawer);
}
